<div class="background glass">
<!--    <div class="mt-1 mb-2 d-flex justify-content-center">-->
<!--        Create a Post-->
<!--    </div>-->
    <div class="post-background">
       <div class="profile-row d-flex justify-content-start align-items-center">
           <span class="profile-image-holder">
                <base64-image [borderRadiusRem]="20" [base64String]="userProfileImageBase64"></base64-image>
           </span>
           <span class="profile-name mx-3">{{user?.display_name ?? 'User'}}</span>
           <span class="post-time mx-1">a few seconds ago</span>
       </div>
        <div class="my-3">
            <div class="editor editor-container dark-theme">
                <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
                <ngx-editor
                        [editor]="editor"
                        [(ngModel)]="html"
                        [placeholder]="'Hello there..'"
                ></ngx-editor>
            </div>
        </div>
        <div class="mx-3 mb-3">
            <div *ngIf="uploadStatuss.length > 0" class="w-100 my-3">
                <div class="text-light overflow-auto w-100 d-flex flex-wrap" style="max-height: 30vh;">
                    @for (upload of uploadStatuss; track upload) {
                        <div class="image-item" style="
                            background-size: cover;
                            background:
                            /* top, transparent black overlay */
                            linear-gradient(
                                rgba(50, 25, 19, 0.95),
                                rgba(50, 25, 19, 0.5)
                            ),
                            /* bottom, image */
                            url('{{upload.fileData}}');
                        ">
                            <div class="mb-1 d-flex justify-content-between">
                                <div>{{ upload.name }}</div>
                                <div class="pointer ps-3 pe-1" (click)="removeImage(upload.id)">x</div>
                            </div>
                            <div class="mb-1 small" *ngIf="!upload.completed">Uploading</div>
                            <div class="mb-1 small" *ngIf="upload.completed">Uploaded</div>
                            <div class="progress mt-2" style="">
                                <div class="progress-bar" role="progressbar" style="width: {{ (upload.progress / upload.total) * 100 }}%">
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
            <div class="d-flex justify-content-center my-2">
                <label class="btn-primary mx-2"  for="file-upload">
                    Add Image/s
                    <fa-icon [icon]="iconsService.faIconsRegular.faImages"></fa-icon>
                </label>
                <input id="file-upload" type="file" (change)="filesSelected($event)" class="file-upload" multiple/>
                <div class="vertical-bar"></div>
                <button class="btn-out mx-2" disabled>Other content coming soon</button>
            </div>
        </div>
    </div>
    {{html}}
    <div class="mt-3 d-flex justify-content-between w-100">
    <button class="btn-out me-2" (click)="closeHolder()">Cancel</button>
    <button class="btn-primary" (click)="post()" [disabled]="html.length<8 || !allUploadsCompleted">Post</button>
  </div>
</div>
